import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirstNamePipe } from './first-name.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ FirstNamePipe ],
    exports: [ FirstNamePipe ],
})
export class FirstNamePipeModule {}
